// imports
import Util from './session';
import WildlandsHeroNFT from './contract/wlHeroNFT';
import WildlandsForwarder from './contract/wlForwarder';
import WildlandsBackpackItem from './contract/wlBackpackItem';
import WildlandsQuestManager from './contract/wlQuestManager';
import WildlandsWalletDelegation from './contract/wlWalletDelegation';

// exports
export const Utils = Util;
export const WLHeroNFT = WildlandsHeroNFT;
export const WLForwarder = WildlandsForwarder;
export const WLQuestManager = WildlandsQuestManager;
export const WLBackpackItem = WildlandsBackpackItem;
export const WLWalletDelegation = WildlandsWalletDelegation;
export default {
  Utils, WLHeroNFT, WLForwarder, WLBackpackItem, WLQuestManager, WLWalletDelegation
};
